import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/auth';
import { publicPaths } from './paths';

/**
 * Gate for the member area.
 *
 * Previously the app layout rendered the login screen in place whenever there
 * was no token. That stopped working once public pages existed: a visitor
 * reading the news has no token and must not be shown a login form.
 *
 * The attempted path is carried in `state` so signing in returns the visitor
 * to where they were going rather than dumping them on the portal.
 */
export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { token } = useAuth();
  const location = useLocation();

  if (!token) {
    return <Navigate to={publicPaths.login} replace state={{ from: location.pathname + location.search }} />;
  }
  return <>{children}</>;
}
